import ProviderBlock from './ProviderBlock';

export default ProviderBlock;
